/**
 * Returns a copy of `options` ordered A-Z by displayed label (WEBV3-347).
 * Case- and accent-insensitive, so "amy adams" sorts with "Amy Adams" rather
 * than after every capital letter. Labels that compare equal keep their input
 * order (Array.prototype.sort is stable), which keeps two same-named
 * employees in a predictable order.
 */
export function sortOptionsByLabel<T extends { label: string }>(
  options: T[]
): T[] {
  return [...options].sort((a, b) =>
    a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
  );
}
